export default __webpack_public_path__ + "static/media/flat.4a6f9f69.png";